import { useEffect, useState } from 'react';
import { Loader2, TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { api } from '../lib/gapApi';

export const HistoricalTrends = ({ companyName }) => {
  const [trendsData, setTrendsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (companyName) {
      fetchTrends();
    }
  }, [companyName]);

  const fetchTrends = async () => {
    setIsLoading(true);
    try {
      const res = await api.get(`/trends/${companyName}`);

      const formatted = res.data.map((item) => {
        const d = new Date(item.timestamp);
        return {
          ...item,
          month: `${d.toLocaleString('default', { month: 'short' })} ${d.getDate()}`
        };
      });
      setTrendsData(formatted);
    } catch (err) {
      console.error("Failed to fetch trends", err);
    } finally {
      setIsLoading(false);
    }
  };

  if (!companyName) return null;

  return (
    <div className="bg-slate-900/60 backdrop-blur-xl rounded-3xl p-8 border border-sky-500/30 shadow-xl mb-12 animate-in fade-in">
      <div className="flex items-center justify-between gap-3 mb-6 border-b border-slate-700/50 pb-4">
        <div className="flex items-center gap-3">
            <TrendingUp className="text-sky-400" size={28} />
            <h2 className="text-2xl font-bold text-white">Historical Sentiment Trends</h2>
        </div>
        <button onClick={fetchTrends} className="text-sm text-sky-400 hover:text-sky-300">
            Refresh Data
        </button>
      </div>

      <div className="h-[350px] w-full">
        {isLoading ? (
          <div className="flex h-full items-center justify-center">
            <Loader2 className="animate-spin text-sky-400" size={32} />
          </div>
        ) : trendsData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={trendsData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
              <XAxis dataKey="month" stroke="#94a3b8" />
              <YAxis domain={[0, 100]} stroke="#94a3b8" />
              <Tooltip
                contentStyle={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '8px', color: '#f8fafc' }}
              />
              <Legend />
              <Line type="monotone" dataKey="brand_score" name="Brand" stroke="#8b5cf6" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 8 }} />
              <Line type="monotone" dataKey="employee_score" name="Employee" stroke="#10b981" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 8 }} />
              <Line type="monotone" dataKey="seo_score" name="SEO" stroke="#f59e0b" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 8 }} />
              <Line type="monotone" dataKey="customer_score" name="Customer" stroke="#3b82f6" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex h-full items-center justify-center">
            <p className="text-slate-500 italic">No historical data available. Run an analysis to generate data.</p>
          </div>
        )}
      </div>
    </div>
  );
};
